import { DEFAULT_LOCALE } from '@ghostscreen/contracts';
import { i18n } from '../../i18n/i18n';

export type AuthErrorLike = {
  message: string;
  code?: string | undefined;
  status?: number | undefined;
  name?: string | undefined;
};

const RATE_LIMIT_CODES = new Set(['over_email_send_rate_limit', 'over_request_rate_limit']);

/** Turns Supabase Auth errors into copy a customer can act on. */
export function mapAuthError(error: AuthErrorLike): string {
  if (error.status === 429 || (error.code && RATE_LIMIT_CODES.has(error.code))) {
    return i18n.t('auth:errors.rateLimit');
  }
  if (error.name === 'AuthRetryableFetchError') {
    return i18n.t('auth:errors.network');
  }
  if (error.code === 'email_address_invalid') {
    return i18n.t('auth:errors.invalidEmail');
  }
  const fallback = i18n.t('auth:errors.sendFailed');
  // Supabase only writes its messages in English.
  if (i18n.resolvedLanguage !== DEFAULT_LOCALE) return fallback;
  return error.message.trim() || fallback;
}
